import React from 'react'
import { Button, DangerButton, Row, Separator, useOverlay } from '@fs/zion-ui'
import { ContentDelete, ContentEdit } from '@fs/zion-icon/dist/cjs/icons'
import { useTranslation } from 'react-i18next'
import KioskInfoData from './KioskInfoData'
import useKioskDetails from './hooks/useKioskDetails'
import ConfirmDeleteKiosk from './ConfirmDeleteKiosk'

export default function KioskDetails({ kiosksState, kiosksActions, editableFieldsRef }) {
  const deleteKioskOverlay = useOverlay()
  const { handleDeleteKiosk, handleSaveChanges } = useKioskDetails({
    kiosksState,
    kiosksActions,
    editableFieldsRef,
    deleteKioskOverlay,
  })
  const { t } = useTranslation()
  return (
    <>
      <Row alignX="end">
        {kiosksState.selectedKiosk && (
          <Row>
            <Button Icon={ContentEdit} id="editKiosk" onClick={() => kiosksActions.setIsEditMode((prev) => !prev)}>
              {t('action.edit', 'Edit')}
            </Button>
            <DangerButton Icon={ContentDelete} id="deleteKiosk" onClick={deleteKioskOverlay.handleClick}>
              {t('action.delete', 'Delete')}
            </DangerButton>
            <ConfirmDeleteKiosk {...deleteKioskOverlay} handleDeleteKiosk={handleDeleteKiosk} />
          </Row>
        )}
      </Row>
      <Separator />
      {kiosksState.selectedKiosk && <KioskInfoData kiosksState={kiosksState} editableFieldsRef={editableFieldsRef} />}
      {kiosksState.isEditMode && (
        <>
          <Separator />
          <Row alignX="end">
            <Button emphasis="medium" id="editKioskCancel" onClick={() => kiosksActions.setIsEditMode(false)}>
              {t('action.cancel', 'Cancel')}
            </Button>
            <Button emphasis="high" id="editKioskSave" onClick={handleSaveChanges}>
              {t('action.save', 'Save')}
            </Button>
          </Row>
        </>
      )}
    </>
  )
}
